class UserClass {

    avatar = null;
    email_address = null;
    first_name = null;
    full_name = null;
    last_name = null;
    phone_number = null;
    user_id = null;

    constructor() {
        return this;
    }

    create = (props = {}) => {
        this.avatar = props.avatar;
        this.first_name = props.first_name;
        this.full_name = props.full_name;
        this.last_name = props.last_name;
        this.phone_number = props.phone_number;
        this.user_id = props.user_id;
        return this;
    }
}

export default {
    create: props => new UserClass().create(props)
}
